module.exports = __webpack_public_path__ + "display/static/img/icon-c.6f440c0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/tui-image-editor/dist/svg/icon-c.svg
// module id = 773
// module chunks = 1 3